import Loader from '@/components/common/Loader';
import loadable from '@/utils/loadable';

export const NotFound = loadable(() => import('@/pages/notFound'), {
  fallback: <Loader />,
});

export const Home = loadable(() => import('@/pages/home'), {
  fallback: <Loader />,
});
//auth pages
export const LoginPage = loadable(() => import('@/pages/auth/LoginPage'), {
  fallback: <Loader />,
});
export const SignupPage = loadable(() => import('@/pages/auth/SignupPage'), {
  fallback: <Loader />,
});
export const ForgetPasswordPage = loadable(() => import('@/pages/auth/ForgetPasswordPage'), {
  fallback: <Loader />,
});

export const Live = loadable(() => import('@/pages/live'), {
  fallback: <Loader />,
});

export const QuizPage = loadable(() => import('@/pages/quizPage'), {
  fallback: <Loader />,
});

export const Referral = loadable(() => import('@/pages/referral'), {
  fallback: <Loader />,
});
export const LiveMatch = loadable(() => import('@/pages/liveMatch'), {
  fallback: <Loader />,
});
export const LeaderBoard = loadable(() => import('@/pages/leaderboard'), {
  fallback: <Loader />,
});
export const QuizPlay = loadable(() => import('@/pages/quizPlay'), {
  fallback: <Loader />,
});
export const GameHistroy = loadable(() => import('@/pages/gameHistory'), {
  fallback: <Loader />,
});
export const Notification = loadable(() => import('@/pages/notification'), {
  fallback: <Loader />,
});

export const ViewQuizHistry = loadable(() => import('@/pages/viewquizHistory'), {
  fallback: <Loader />,
});

export const QuizResults = loadable(() => import('@/pages/quizResults'), {
  fallback: <Loader />,
});
export const ActiveCampaigns = loadable(() => import('@/pages/activeCampaigns'), {
  fallback: <Loader />,
});
export const CampaignLeadeboard = loadable(() => import('@/pages/campaignLeadeboard'), {
  fallback: <Loader />,
});
export const Transections = loadable(() => import('@/pages/Transections'), {
  fallback: <Loader />,
});

